//
// TableElementController.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./DataVisualElementController";
import "../../models/visualElements/table/TableSummary";
import "../../models/visualElements/TableElement";
import "../../models/visualElements/table/AbstractTableColumn";
import "@sas-dvr/ltjs-commons/styles/StyleChain";
import "@sas-dvr/ltjs-commons/models/data/dataset/DataSet";
import "@sas-dvr/ltjs-commons/rules/interfaces/Rule";
import "@sas-dvr/ltjs-commons/models/data/sorting/SortDirection";

var TableElementController = createModule("BIRD::TableElementController", ["BIRD::BIRDModelController","BIRD::RendererManagerController","BIRD::VisualElementController","BIRD::DataVisualElementController"], EventDispatcher, [
    ,
    ,
    ,
    {
        summary: 1,
    },
    {
        getColumnHeader: [7,1],
        getTotalStyleChain: [1],
        getOrderedHiddenTableColumns: [[1]],
        canSort: [2,4],
        getSortedColumnNamesInOrder: [[7]],
        applyRule: [0,4,4,1],
        setColumnOrder: [0,[1]],
        getTableStyleChain: [1],
        updateView: [0,1,2],
        getSortDirectionForColumn: [4,7],
        addSort: [0,7,4,2],
        setSortEnabled: [0,2],
        generateDisplayRule: [1,1],
        getTableHeaderStyleChain: [1],
        getSparkLineDataSet: [1,4,4],
        getPrimarySortColumnName: [7],
        setVisibilityForColumn: [0,1,2],
        getModel: [1],
        getBrushStyleChain: [1],
        getOrderedTableColumnStyleChains: [[1]],
        showTooltip: [0,7,4,4,2],
        sort: [0,7,4],
        isSortEnabled: [2],
        getSortIndicies: [[3]],
        getOrderedTableColumns: [[1]],
        getSelectedStyleChain: [1],
        getPresentationLabel: [7],
        getTotalLabelForColumn: [7,7],
        moveColumn: [0,4,4],
        getOrderedColumnLabels: [[7]],
    },
    {
        _create: [4,1],
    },
    ,
]);
export default TableElementController;
